<template>
  <div>
    <a href="javascript:void(0);" class="button white" :class="color" @click="fnExcel"><span>{{name}}</span></a>
  </div>
</template>

<script>
import Vue from 'vue'
import FileUtils from '@/modules/file'
import AppConfig from '@/config'

export default {
  name: 'buttonExcel',
  props: {
    url: "",
    fileName: "",  
    color: {
      type: String,
      default: "blue"
    },    
    name: {
      type: String,
      default: "엑셀다운"
    },
    params : {
      type: Object
    }
  },
  data () {
    return {
    }    
  },
  methods: {
    fnExcel() {
      var agent = navigator.userAgent.toLowerCase()

      if ( (navigator.appName == 'Netscape' && navigator.userAgent.search('Trident') != -1) || (agent.indexOf("msie") != -1) ) {
        var xAuthToken = Vue.httpClient.defaults.headers.common['x-auth-token'];
        var url    = this.url +'?xAuthToken='+ xAuthToken;
        var params = this.params;

        if ( params ) {
          Object.keys(params).forEach(function (key, index) {
            url = url + "&" + key + "=" + params[key];
          });
        }

        location.href = AppConfig.HTTP_CONFIG.baseURL + url;
      } else {
        Vue.httpClient
          .get(this.url, {
            responseType: 'arraybuffer',
            params : this.params
          })
          .then((response) => {
            FileUtils.getExcelFile(response, this.fileName)
          })        
      }
    }
  }  
}
</script>

<style scoped>
  div {
        display:inline;
  }
</style>


// WEBPACK FOOTER //
// src/components/ButtonExcel.vue